export const getUser = userId => ({ users }) =>
  users.usersList.find(({ id }) => id === +userId);
